import { render, staticRenderFns } from "./i-drag-mover.vue?vue&type=template&id=325c58e3&scoped=true&"
import script from "./i-drag-mover.vue?vue&type=script&lang=js&"
export * from "./i-drag-mover.vue?vue&type=script&lang=js&"
import style0 from "./i-drag-mover.vue?vue&type=style&index=0&id=325c58e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325c58e3",
  null
  
)

export default component.exports